import { isAdmin } from '@/constants/roles';
import { isEmbeddedSidebar } from '@/lib/embedded-sidebar';
import { cn } from '@/lib/utils';
import { PanelRightClose, Settings, ShieldUser } from 'lucide-react';
import { memo, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';

import { useConfig } from '@chainlit/react-client';

import ButtonLink from '@/components/ButtonLink';
import { Button } from '@/components/ui/button';
import { useSidebar } from '@/components/ui/sidebar';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger
} from '@/components/ui/tooltip';

import { useAuth } from '@/hooks/useAuth';

import { chatSettingsOpenState, rightSidebarPanelState } from 'state/project';

import ApiKeys from './ApiKeys';
import ChatProfiles from './ChatProfiles';
import DMThreadNameHeader from './DMThreadNameHeader/DMThreadNameHeader';
import NewChatButton from './NewChat';
import SidebarTrigger from './SidebarTrigger';
import { ThemeToggle } from './ThemeToggle';
import UserNav from './UserNav';

const Header = memo(() => {
    const navigate = useNavigate();
    const { data, user } = useAuth();
    const { config } = useConfig();
    const { open, openMobile, isMobile, setOpenMobile } = useSidebar();
    const setChatSettingsOpen = useSetRecoilState(chatSettingsOpenState);
    const [rightSidebarPanel, setRightSidebarPanel] = useRecoilState(
        rightSidebarPanelState
    );

    // Check if user has admin role
    const userIsAdmin = useMemo(() => {
        return isAdmin(user?.metadata?.organization_roles);
    }, [user]);

    if (isEmbeddedSidebar) {
        // Embedded chat has no left sidebar (thread history is not available
        // inside a report), so no sidebar trigger — just "new chat".
        return (
            <div
                className="relative flex items-center gap-2 px-4 py-3.5"
                id="header"
            >
                <NewChatButton navigate={navigate} />
            </div>
        );
    }

    const sidebarOpen = isMobile ? openMobile : open;

    const historyEnabled = data?.requireLogin && config?.dataPersistence;

    const links = config?.ui?.header_links || [];
    const rightSidebarOpen = rightSidebarPanel !== null;

    return (
        <div
            className="relative flex justify-between items-stretch gap-2 px-4 py-3 min-h-14"
            id="header"
        >
            <div className="flex items-center">
                {/* Mobile menu button */}
                {isMobile && historyEnabled && (
                    <div className="flex items-center">
                        <Button
                            onClick={() => setOpenMobile(true)}
                            variant="ghost"
                            size="icon-sm"
                            className="mr-2"
                        >
                            <SidebarTrigger />
                        </Button>
                        <NewChatButton></NewChatButton>
                    </div>
                )}

                {/* {historyEnabled ? !sidebarOpen ? <SidebarTrigger /> : null : null}
        {historyEnabled  ? (
          !sidebarOpen ? (
            <NewChatButton navigate={navigate} />
          ) : null
        ) : (
          <NewChatButton navigate={navigate} />
        )} */}

                <ChatProfiles navigate={navigate} />

                <DMThreadNameHeader></DMThreadNameHeader>
            </div>

            <div />
            <div className="flex items-center gap-1 h-full">
                {/* <ApiKeys />
                {userIsAdmin && (
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={cn(
                                        'text-muted-foreground hover:text-muted-foreground'
                                    )}
                                    onClick={() =>
                                        navigate('/admin', { replace: true })
                                    }
                                >
                                    <ShieldUser className="size-5!" />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Admin</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                )}
                {links &&
                    links.map((link, index) => (
                        <ButtonLink
                            key={`${link.name}-${link.url}-${index}`}
                            name={link.name}
                            displayName={link.display_name}
                            iconUrl={link.icon_url}
                            url={link.url}
                        />
                    ))}
                <ThemeToggle />
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Button
                                onClick={() => setChatSettingsOpen(true)}
                                variant="ghost"
                                size="sm"
                                className={cn(
                                    'text-muted-foreground hover:text-muted-foreground'
                                )}
                            >
                                <Settings className="size-5!" />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>Settings</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider> */}
                {/* <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Button
                                onClick={() =>
                                    setRightSidebarPanel(
                                        rightSidebarOpen ? null : 'charts'
                                    )
                                }
                                variant="ghost"
                                size="sm"
                                className={cn(
                                    'text-muted-foreground hover:text-muted-foreground'
                                )}
                            >
                                <PanelRightClose className="size-5!" />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>
                                {rightSidebarOpen
                                    ? 'Close panel'
                                    : 'Open panel'}
                            </p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider> */}

                {/* <UserNav /> */}
            </div>
        </div>
    );
});

export { Header };
